import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Select, Button, Spin, DatePicker } from 'antd';
import { errHandler } from '../../helper/helper';
import { generateLoanReportForDay } from "./LoanService";
import LoanSummaryForDayExcel from '../../Utils/Loan/LoanSummaryForDayExcel';
import { disabledDate } from "../../Utils/Util";
import { headerStyle, subtotalStyle } from "../../Utils/excelStyle";



const { Option } = Select;

const LoanSummaryForADay = ({
    loginPlaceId,
    products,
    districtData,
    districtName,
    branchId,
    divisionalAreaId,
}) => {
    const [selections, setSelections] = useState({
        districts: [],
        divisionalAreas: [],
        branches: [],
        products: [],
        date: null
    });

    const [availableBranches, setAvailableBranches] = useState([]);
    const [availableDivisionalAreas, setAvailableDivisionalAreas] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let filteredDivisionalAreas = [];

        if (loginPlaceId === "2" && divisionalAreaId) {
            filteredDivisionalAreas = districtData
                .flatMap(d => d.divisionalAreaDtoList || [])
                .filter(div => div.divAId === divisionalAreaId);

            setSelections(prev => ({ ...prev, divisionalAreas: [divisionalAreaId] }));
        } else if (loginPlaceId === "4") {
            filteredDivisionalAreas = districtData
                .filter(d => d.districtName === districtName)
                .flatMap(d => d.divisionalAreaDtoList || []);
        } else {
            filteredDivisionalAreas = districtData
                .filter(d => selections.districts.includes(d.districtId))
                .flatMap(d => d.divisionalAreaDtoList || []);

            setSelections(prev => ({
                ...prev,
                divisionalAreas: prev.divisionalAreas.filter(did =>
                    filteredDivisionalAreas.some(d => d.divAId === did)
                )
            }));
        }

        setAvailableDivisionalAreas(filteredDivisionalAreas);
    }, [selections.districts, districtData, loginPlaceId, divisionalAreaId, districtName]);

    useEffect(() => {
        const filteredBranches = districtData
            .flatMap(d => d.divisionalAreaDtoList || [])
            .filter(div => selections.divisionalAreas.includes(div.divAId))
            .flatMap(div => div.branchDtoList || []);

        setAvailableBranches(filteredBranches);
        setSelections(prev => ({
            ...prev,
            branches: prev.branches.filter(bid => filteredBranches.some(b => b.id === bid))
        }));
    }, [selections.divisionalAreas, districtData]);

    const generateReport = async () => {
        if (loginPlaceId !== "1" && !selections.branches.length) {
            errHandler();
            return;
        }

        if (!selections.products.length) {
            errHandler();
            return;
        }

        if (!selections.date) {
            errHandler();
            return;
        }

        const formattedDate = selections.date.format("YYYY-MM-DD");

        const data = {
            selectedDate: formattedDate,
            branchIdList: loginPlaceId === "1" ? [parseInt(branchId)] : selections.branches,
            productIdList: selections.products,
            isExcel: true
        };

        try {
            setLoading(true);

            const res = await generateLoanReportForDay(data);
            const reportData = res?.data || res;

            LoanSummaryForDayExcel(reportData, headerStyle, subtotalStyle, formattedDate, loginPlaceId);

        } catch (err) {
            errHandler(err);
        } finally {
            setLoading(false);
        }
    };

    const isGenerateDisabled =
        loading ||
        !selections.date ||
        (loginPlaceId !== "1" && selections.branches.length === 0) ||
        selections.products.length === 0;

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">

                    {loginPlaceId === "3" && (
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Form.Item label="Select Districts">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select districts"
                                        style={{ width: '100%' }}
                                        value={selections.districts}
                                        onChange={(values) => {
                                            if (values.includes("ALL")) {
                                                setSelections(prev => ({
                                                    ...prev,
                                                    districts: districtData.map(d => d.districtId)
                                                }));
                                            } else {
                                                setSelections(prev => ({ ...prev, districts: values }));
                                            }
                                        }}
                                        maxTagCount="responsive"

                                    >
                                        <Option key="ALL" value="ALL">🌍 Select All Districts</Option>
                                        {districtData.map(d => (
                                            <Option key={d.districtId} value={d.districtId}>
                                                🏙️ {d.districtName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Form.Item label="Select Divisional Areas">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select divisional areas"
                                        style={{ width: '100%' }}
                                        value={selections.divisionalAreas}
                                        onChange={(values) => {
                                            if (values.includes("ALL")) {
                                                setSelections(prev => ({
                                                    ...prev,
                                                    divisionalAreas: availableDivisionalAreas.map(d => d.divAId)
                                                }));
                                            } else {
                                                setSelections(prev => ({ ...prev, divisionalAreas: values }));
                                            }
                                        }}
                                        maxTagCount="responsive"
                                        disabled={loginPlaceId === "2"}
                                    >
                                        <Option key="ALL" value="ALL">🌐 Select All Divisional Areas</Option>
                                        {availableDivisionalAreas.map(d => (
                                            <Option key={d.divAId} value={d.divAId}>
                                                🏙️ {d.divAIdName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    {(loginPlaceId === "2" || loginPlaceId === "3" || loginPlaceId === "4") && (
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Form.Item label="Select Branch(es)">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select branches"
                                        style={{ width: '100%' }}
                                        value={selections.branches}
                                        onChange={(values) => {
                                            if (values.includes("ALL")) {
                                                setSelections(prev => ({
                                                    ...prev,
                                                    branches: availableBranches.map(b => b.id)
                                                }));
                                            } else {
                                                setSelections(prev => ({ ...prev, branches: values }));
                                            }
                                        }}
                                        maxTagCount="responsive"
                                        disabled={availableBranches.length === 0}
                                    >
                                        <Option key="ALL" value="ALL">🏢 Select All Branches</Option>
                                        {availableBranches.map(branch => (
                                            <Option key={branch.id} value={branch.id}>
                                                🏢 {branch.branchName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Products">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    placeholder="Select products"
                                    style={{ width: '100%' }}
                                    value={selections.products}
                                    onChange={(values) => {
                                        if (values.includes('ALL')) {
                                            setSelections(prev => ({
                                                ...prev,
                                                products: products.map(p => p.productId)
                                            }));
                                        } else {
                                            setSelections(prev => ({ ...prev, products: values }));
                                        }
                                    }}
                                    maxTagCount="responsive"

                                >
                                    <Option key="ALL" value="ALL">🔘 Select All Products</Option>
                                    {products.map(product => (
                                        <Option key={product.productId} value={product.productId}>
                                            {product.productCode} - {product.productName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Date">
                                <DatePicker
                                    onChange={(date) => setSelections(prev => ({ ...prev, date }))}
                                    disabledDate={disabledDate}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    onClick={generateReport}
                                    disabled={isGenerateDisabled}
                                    className="generate-btn"
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default LoanSummaryForADay;
